import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { User } from '../../../models/user/user';
import { UserPic } from '../../../models/user/user-pic';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {
    
  // Inject the HttpClient service to make HTTP requests
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/Usuario`;

  /**
   * Insert/Update an user
   * @param usuario - User data to insert/update the table
   * @returns Observable with the API's response
   */
  upsertUser(usuario: User): Observable<User> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<User>(`${this.apiUrl}/upsert-user`, usuario, { 
      headers 
    });
  }

  /**
   * Insert/Update an user picture
   * @param userPic - User data to insert/update the table
   * @returns Observable with the API's response
   */
  upsertUserPic(userPic: UserPic): Observable<UserPic> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<UserPic>(`${this.apiUrl}/upsert-user-pic`, userPic, { 
      headers 
    });
  }


}
